import { v4 as uuidv4 } from 'uuid';

export const getDeviceId = (): string => {
  let deviceID = localStorage.getItem('deviceID');
  if (!deviceID) {
    deviceID = uuidv4();
    localStorage.setItem('deviceID', deviceID);
  }
  return deviceID;
};
